module.exports = __webpack_public_path__ + "img/superiority_icon1.a1aa0d1.png";